import { createFileRoute } from '@tanstack/react-router';

import { chatbotDetailScreen, chatbotDetailSearch, loadChatbotDetailScreen, loadChatbotMessages } from '@/modules/chatbot/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// `/chatbot/:id` (router.tsx:764-774); `novo` é o cadastro. A aba vai em `?tab=` (U42).
export const Route = createFileRoute('/_app/chatbot/$id/')({
  validateSearch: chatbotDetailSearch,
  staticData: { screen: chatbotDetailScreen },
  loader: () => loadChatbotMessages(),
  component: lazyScreen(loadChatbotDetailScreen, 'ChatbotDetailRouteScreen'),
});
